export const TAXONOMY_ROOT_TAXON_CODE = 'N';
export const GENUS_RANK_CODE = 'genus';
export const SPECIES_RANK_CODE = 'species';
export const SUBMITTABLE_RANK_CODES = [GENUS_RANK_CODE, SPECIES_RANK_CODE];

export const taxonomyLevelKeys = [
  'kingdom',
  'phylum',
  'class',
  'order',
  'family',
  'genus',
  'species',
];
